import React, { Component } from 'react';
import {DataTable} from 'primereact/components/datatable/DataTable';
import {Column} from 'primereact/components/column/Column';
import {Accordion} from 'primereact/components/accordion/Accordion';
import {AccordionTab} from 'primereact/components/accordion/Accordion';
import AiAppointment from './AiAppointment';
import { SPECIAL_NOTE_ACTIVATE,SPECIAL_NOTE } from '../constants';

export class AiReview extends Component {
        

   

    render() {
     //   console.log('REVIEW render')
        var w = window.innerWidth
        var h = window.innerHeight
        if (w > 640) {
            w=640
        }
        if (h > 640) {
            h=640
        }
        var note1 =<div>Actual presentation might appear slightly different from preview. Aquamarine stones come in a variety of shades and in some instances appear clear in color. Your stone may not be as vibrant as the image depicted above. Our experts will ensure the proper size and placement of your message. Inappropriate and profane language may result in the cancellation of your order.</div>
        const note1zales =<div>Actual presentation might appear slightly different from preview. Aquamarine stones come in a variety of shades and in some instances appear clear in color. Your stone may not be as vibrant as the image depicted above. Our experts will ensure the proper size and placement of your message. Inappropriate and profane language may result in the cancellation of your order.</div>
        //const note2a = <div><font color='red'>Due to COVID-19, shipping is taking longer than expected. We will do our best to make sure your package arrives in time for Mother’s Day. This delivery date overrides regular processing times noted below.</font></div>
       // var note2a = <div><font color='red'>Order by Friday, April 23, 2021 for Mother's Day delivery. This delivery date overrides regular processing times. </font></div>
        var note2a = <div><font color='red'></font></div>
        var note2 = <div>Order processing requires <font color='red'>8 Business Days PLUS shipping</font> time based on the shipping method you choose. Signature required for items over $1,000.</div>
        
        //const note2a = <div><font color='red'>Due to COVID-19, shipping is taking longer than expected. We will do our best to make sure your package arrives in time for Mother’s Day. This delivery date overrides regular processing times noted below.</font></div>
        if (SPECIAL_NOTE_ACTIVATE)
            note2a = <div><font color='red'>{SPECIAL_NOTE}</font></div>
        //console.log('REVIEW STATE2',window.currentSite)
        if (['zales','zalesoutlet','gordonsjewelers','pagoda','peoplesjewellers'].includes(window.currentSite))
            {
           //  note2a=''   
             note2 = <div>Order processing requires <font color='red'>8 Business Days PLUS shipping</font> time based on the shipping method you choose. Signature required for items over $1,000.</div>
             note1 = note1zales
             }
             
        note2 = <div>Signature required for items over $1,000.</div>
            
        //const note2a = <div><font color='red'></font></div>
        //const note2 = <div></div>
        let noteGem =''
        let headercolor ='ai-review-header ai-review-' + window.currentSite
        var note1b = ''
      
        if (this.props.bolo)
            note1b = ' cannot be resized'

        if (this.props.lgd)
         noteGem = <div>This jewelry is made with lab-grown diamonds. Lab-grown diamonds have the same optical, chemical and physical properties as diamonds created by the earth. Merchandise which includes lab-grown diamonds is eligible for trade-in under the Lifetime Diamond Trade-In Policy.</div>
        else if (this.props.gems)
         noteGem = <div>Most natural gemstones pictured have been subject to an enhancement process or treatment (e.g. heating, oiling, diffusion, waxing, etc.), which may not be permanent and may require special care. Please refer to the FAQ section below for more information about gemstone enhancements and special care recommendations.</div>
        return (
            <div className={"ai-review ai-show"  /*+ this.props.showReview */} >
                <Accordion  onTabOpen={this.props.onOpenReview} activeIndex={0}>
                <AccordionTab header='Product Overview and Details' /* header="Review"  */  headerClassName={headercolor}  icon="pi pi-plus" >
                        <div className='ai-review-title'> {this.props.description}</div> 
                        <DataTable value={this.props.properties}>
                        <Column field="property" header="Property"  style={{width:'35%'}}/>
                        <Column field="value" header="Value" />
                       
                        </DataTable>
                        
                        <div className='ai-review-note'>
                        {noteGem}
                        </div>       
                        <div className='ai-review-note'>
                        {note1}
                        </div>       
                        <div className='ai-review-note'>
                        {note1b}
                        </div>       
                        <div className='ai-review-note'>
                        {note2a}
                        </div>      
                        <div className='ai-review-note'>
                        {note2}
                        </div>       
                        <AiAppointment/>
                        <div className='ai-version'>Version {this.props.version}</div>
                    </AccordionTab> 
                    
                </Accordion>
            </div>
        )
    }
}
export default AiReview;



// WEBPACK FOOTER //
// ./src/layout/AiReview.js